module.exports = __webpack_public_path__ + "i18n/ja.4aeb3790af7d0986a4112aa93ce9a3e1.json";